import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Update orchid pro
 */
export default async function postOrchidPro(
  nextOrchidPro: Partial<OrchidPro>,
  onBehalfOf?: string,
): Promise<OrchidPro> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/orchid_pro/${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "PUT",
      body: JSON.stringify(nextOrchidPro),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
